<template>
  <div class="card card-custom mb-0 pb-0">
    <div class="card-header d-flex justify-content-center p-4">
      <h4 class="mb-0">{{ $t('collection.add_collection') }}</h4>
    </div>
    <div class="card-body py-0">
      <div class="row justify-content-center px-4">
        <div class="col-5 text-center">
          <img id="collection-image-holder" class="img-fluid mb-3" :src="cover_image_link" alt="" />

          <input ref="file" style="display: none" accept="image/*" type="file" @change="onChangeFile" />
          <button class="btn btn-sm btn-outline-primary mb-2" type="button" @click="$refs.file.click()">
            {{ $t("collectionDetail.add_image") }}
          </button>

          <p class="collection-image-help" v-html="$t('general.catalog_cover_image_info', {
            formats: '<b>.jpg, .png, .gif</b>',
            dimensions: '<b>521x288</b>'
          })"></p>

        </div>
        <div class="col-7">
          <input type="text" class="uk-input" :placeholder="$t('education.please_add_collection_name')"
            v-model="collectionName">

          <textarea v-model="description" class="uk-textarea mb-3" :placeholder="$t('collectionDetail.description')">
            </textarea>

          <multiselect v-model="hashtags" :multiple="true" :openDirection="'bottom'" :options="hashtags_options"
            :taggable="true" :appendToBody="true" deselectGroupLabel="Grubun seçimini kaldırmak için enter'a basın"
            deselectLabel="Kaldırmak için enter'a basın" label="name" :placeholder="$t('general.add_tag')"
            selectGroupLabel="Grup seçmek için enter'a basın" selectLabel="Seçmek için enter'a basın"
            selectedLabel="Seçilmiş" :tag-placeholder="$t('general.add_tag')" track-by="id"
            @change="(val) => { hashtags = val }" @close="isClosedHashtagSelector = true"
            @open="isClosedHashtagSelector = false" @tag="addTag" />

          <div class="d-flex justify-content-start align-items-center mt-3 mb-3">
            <span class="mr-2">{{ $t('collectionDetail.is_public') }}</span>
            <label class="uk-switch mb-0" for="is_public_check">
              <input type="checkbox" v-model="isPublic" id="is_public_check">
              <div class="uk-switch-slider"></div>
            </label>
          </div>

        </div>
      </div>
    </div>

    <div class="card-footer d-flex justify-content-center p-4">
      <button @click="closeModal" class="btn btn-secondary btn-sm mr-3">
        {{ $t('education.new_send_close') }}
      </button>
      <button @click="onSubmit" :disabled="collectionName === null || collectionName === ''"
        class="btn btn-primary btn-sm">
        <i class="uil-check"></i>
        {{ $t('education.new_send') }}
      </button>
    </div>
  </div>
</template>

<script>

import $ from "jquery";
import Multiselect from "vue-multiselect";
import { CREATE_ITEM, GET_ITEMS } from "@/core/services/store/REST.module";

export default {
  name: "AddCollectionModal",
  components: {
    Multiselect
  },
  props: {},
  data() {
    return {
      collectionName: null,
      description: null,
      collectionUrl: "api/collection",
      cover_image_link: process.env.VUE_APP_BACKEND_APP_URL + "/no-photo.png",
      isPublic: 0,
      hashtags: [],
      isClosedHashtagSelector: false,
      hashtags_options: [],
    }
  },
  mounted() {
    this.loadTags();
  },
  methods: {
    loadTags() {
      this.$store.dispatch(GET_ITEMS, {
        url: "api/collection-tags",
        acceptPromise: true
      }).then((result) => {
        if (result.status && result.data) {
          // String array'i object array'e dönüştür
          this.hashtags_options = result.data.map(tag => ({
            name: tag,
            id: tag
          }));
        }
      });
    },
    addTag(newTag, id = null) {
      var regexp = /[<>{}();\/\\]/;
      if (regexp.test(newTag) || newTag.trim().length === 0) {
        return false;
      }
      const tag = {
        name: newTag,
        id: id ?? 'custom_' + newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.hashtags_options.push(tag);
      this.hashtags.push(tag);
    },
    onChangeFile() {
      let value = this.$refs.file.files[0];
      this.collectionImage = value;
      let blob = URL.createObjectURL(value);
      let imageHolder = $("#collection-image-holder");
      imageHolder.attr("src", blob);
    },
    onSubmit(payload) {
      let self = this;
      let value = this.$refs.file.files[0];

      let form = new FormData();

      form.append("name", this.collectionName);
      form.append("description", this.description);
      form.append("is_public", this.isPublic === true ? 1 : 0);
      form.append("cover_image", value);

      form.append("tags", JSON.stringify(this.hashtags));

      this.$store.dispatch(CREATE_ITEM, {
        url: this.collectionUrl,
        contents: form,
        acceptPromise: true
      })
        .then((result) => {
          if (!self.restError) {
            self.$emit("onSubmit", {
              success: true,
              data: result.data,
            });
          } else {
            self.$emit("onSubmit", {
              success: false,
              message: self.restError
            });
          }
        });
    },
    closeModal() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.button {
  border-radius: 20px;
}

.collection-image-help {
  margin: 0;
  font-size: 12px;
  line-height: 1.45;
  color: #64748b;
  text-align: left;
}

#collection-image-holder {
  display: block;
  width: min(100%, 220px);
  aspect-ratio: 16 / 9;
  max-height: 124px;
  margin-left: auto;
  margin-right: auto;
  object-fit: cover;
  border-radius: 8px;
}

@media (max-width: 768px) {
  .card-custom .card-header,
  .card-custom .card-body,
  .card-custom .card-footer {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .card-custom .card-body .row {
    display: block;
    margin-left: 0;
    margin-right: 0;
  }

  .card-custom .card-body .col-5,
  .card-custom .card-body .col-7 {
    width: 100%;
    max-width: 100%;
    flex: 0 0 100%;
    padding-left: 0;
    padding-right: 0;
  }

  #collection-image-holder {
    width: min(100%, 220px);
    max-height: 124px;
  }

  .card-custom input.uk-input,
  .card-custom textarea.uk-textarea,
  .card-custom .multiselect__tags {
    min-height: 48px;
    font-size: 16px;
    box-sizing: border-box;
  }

  .card-custom textarea.uk-textarea {
    min-height: 112px;
    line-height: 1.5;
  }

  .card-custom .card-footer {
    flex-wrap: wrap;
    gap: 8px;
  }

  .card-custom .card-footer .btn {
    min-height: 48px;
    margin: 0 !important;
    flex: 1 1 140px;
  }
}
</style>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.uk-sticky-fixed {
  margin: 0 !important;
}

.multiselect .multiselect__input {
  border: unset !important;
  border: 0 !important;
  box-shadow: none;
  outline: none;
}

.multiselect .multiselect__content-wrapper {
  max-height: 200px !important;
  overflow-y: auto !important;
  z-index: 99999999 !important;
  position: absolute !important;
}

</style>
